<template>
  <div>
    <AppDrawer />
    <AppBar />
    <v-main>
      <v-container fluid class="admin-design__container">
        <slot></slot>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import AppDrawer from '@/infrastructure/vue/components/common/navigations/AppDrawer';
import AppBar from '@/infrastructure/vue/components/common/bars/AppBar';
export default {
  name: 'AdminDesign',
  components: {
    AppDrawer,
    AppBar,
  },
  data: () => ({}),
};
</script>
<style lang="scss" scoped>
.admin-design {
  &__container {
    padding: 40px 50px;
  }
}
</style>
